import { ThunkResult } from "../../shared/utilities";
import { IAction } from "../model/IAction";
import { ElementType, IParameterSchema, ITaskData } from "../model/IProcessData";
import { State } from "../model/State";
import { TestElementId } from "./SidePanelActions";
import { updateSelectedTypeId } from "./UpdateSelectedType";

export const UPDATE_TARGET_FRAMEWORK = "UPDATE_TARGET_FRAMEWORK";
export function updateTargetFramework(frameworkId: string, skipValidation?: boolean): ThunkResult<void, State> {
  return (dispatch, getState) => {
    const state = getState();
    for (const [elementId, element] of Object.entries(state.elements)) {
      if (element.type === ElementType.Task) {
        const currentTask = state.tasks.find((t) => t.uri === element.selectedTypeId);
        if (!currentTask) {
          // If current configured task not found we wont do anything. This should not happen.
          continue;
        }

        if (TaskIsCompatibleWithTargetFramework(currentTask, frameworkId)) {
          continue;
        }

        const newTaskMatchingFx = state.tasks.find((t) =>
          TaskIsCompatibleWithTargetFramework(t, frameworkId)
          && t.name === currentTask.name
          && t.packageName === currentTask.packageName);

        if (newTaskMatchingFx) {
          const schema = JSON.parse(newTaskMatchingFx.argumentsJson) as IParameterSchema[];
          dispatch(updateSelectedTypeId(elementId, newTaskMatchingFx.uri, schema, element.parameters, skipValidation));
        }
        // if no match, do not update the task, but let the validation highlight the incompatiblity
      }
    }
    dispatch<UpdateTargetFrameworkAction>({
      type: UPDATE_TARGET_FRAMEWORK,
      frameworkId: frameworkId
    });
  };

  function TaskIsCompatibleWithTargetFramework(task: ITaskData, frameworkId: string) {
    switch (frameworkId) {
      case "netstandard2.0":
        return task.isStandard;
        case "net6.0":
        case "net8.0":
        return task.isStandard || task.isDotNet;
      case "net471":
        return !(task.isStandard || task.isDotNet);
    }
    console.warn(`Unexpected frameworkId ${frameworkId}`)
    return false;
  }
}

export function updateTestTaskTargetFramework(isCrossPlatform: boolean): ThunkResult<void, State> {
  return (dispatch, getState) => {
    const state = getState();
    const testElement = state.elements[TestElementId]
    const currentTask = state.tasks.find((t) => t.uri === testElement.selectedTypeId);
    if (!currentTask) {
      // If current configured task not found we wont do anything. This should not happen.
      return;
    }

    const currentTaskIsCorrectTargetFx = (isCrossPlatform && (currentTask.isStandard || currentTask.isDotNet)) // if target agentgroup is crossplatform both standard and dotnet is fine.
      || (!isCrossPlatform && !currentTask.isDotNet && !currentTask.isStandard); // if target is legacy agent non standard or dotnet is required
    if (currentTaskIsCorrectTargetFx) {
      // matching task
      return;
    }

    const newTaskMatchingFx = state.tasks.find((t) =>
      (isCrossPlatform ? t.isDotNet || t.isStandard : !t.isDotNet && !t.isStandard)
      && t.name === currentTask.name
      && t.packageName === currentTask.packageName);

    if (newTaskMatchingFx) {
      const schema = JSON.parse(newTaskMatchingFx.argumentsJson) as IParameterSchema[];
      dispatch(updateSelectedTypeId(TestElementId, newTaskMatchingFx.uri, schema, testElement.parameters));
    }
  }
}

export interface UpdateTargetFrameworkAction extends IAction {
  frameworkId: string;
}
